import { api } from '@/core/http/apiClient';

export interface SubscriptionAddon {
  externalName: string;
  appUrl: string;
  iconSrc: string;
  content: string;
  isDisplay: boolean;
  isDisabled: boolean;
}

/** `SubscriptionPortal/retrieveSubscription`; the header reads `isSuccess`, `data.listofAddons` and `data.picture`. */
export interface SubscriptionResponse {
  isSuccess: boolean;
  data?: { listofAddons?: SubscriptionAddon[]; picture?: string };
}

export const subscriptionService = {
  retrieveSubscription: () => api.get<SubscriptionResponse>('SubscriptionPortal/retrieveSubscription'),
};
